import styles from "../landing-page-four.module.css";
import { CTAButton } from "BEDROCK/shared-components/cta-button";
import { usePaths } from "BEDROCK/paths";

interface HeaderSectionProps {
  onClickStart: () => void;
}

export const HeaderSection = (props: HeaderSectionProps) => {
  return (
    <div className={styles.headerSectionContainer}>
      <div className={styles.headerTitles}>
        <h1 className={styles.headerSectionTitle}>
          Too epic for your
          <br />
          camera roll
        </h1>
        <h2 className={styles.headerSectionSubtitle}>
          Turn your trails into art worth hanging
        </h2>
      </div>
      <CTAButton title="BROWSE" onClick={props.onClickStart} />
    </div>
  );
};
